var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import onEnter from "@irati/utils/onEnter";
import { spacingCss } from "../../global/css";
var InnerSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (_a) {
    var inline = _a.inline;
    return (inline ? "inline-block" : "block");
});
var Outer = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  display: ", ";\n\n  &:focus, ", ":focus {\n    outline: none;\n  }\n\n  &:focus > ", " {\n    box-shadow: 0 0 0 2px #015FCC;\n  }\n  ", "\n"], ["\n  cursor: pointer;\n  display: ", ";\n\n  &:focus, ", ":focus {\n    outline: none;\n  }\n\n  &:focus > ", " {\n    box-shadow: 0 0 0 2px #015FCC;\n  }\n  ", "\n"])), function (_a) {
    var inline = _a.inline;
    return (inline ? "inline-block" : "block");
}, InnerSpan, InnerSpan, spacingCss);
var FocusOnKeyboard = function (_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, _c = _a.inline, inline = _c === void 0 ? true : _c, _d = _a.className, className = _d === void 0 ? "" : _d, props = __rest(_a, ["children", "inline", "className"]);
    return (React.createElement(Outer, __assign({ inline: inline, role: "button", tabIndex: 0, onKeyPress: function (e) { return onEnter(e, props.onClick); } }, props),
        React.createElement(InnerSpan, { inline: inline, className: className, tabIndex: -1 }, children)));
};
export default FocusOnKeyboard;
var templateObject_1, templateObject_2;
